import {modals as modalsEnum} from '../../../modules/constants-enumerate';
import {SimpleModal} from '@modules/simple-modal';

const modals = {
  [modalsEnum.LICENSE_DISTRIBUTE]: {
    resolve: () => import('./distribute-modal')
  },
  [modalsEnum.LICENSE_TAKE]: {
    resolve: () => import('./license-take-modal')
  }
};

SimpleModal.addModals(modals);
